import React, { useContext, useEffect, useState } from "react";
import { Nav, Button, Form } from "react-bootstrap";
import { IoSearchOutline } from "react-icons/io5";
import DataTable from "react-data-table-component";
import ReactApexChart from "react-apexcharts";
import graphimage from "../assets/images/graphimage.png";
import showIcon from "../assets/images/Showicon.png";
import filtericon from "../assets/images/Filter.png";
import { RiArrowDropDownLine } from "react-icons/ri";
import { BsThreeDots } from "react-icons/bs";
import DashboardOrder from "./DashboardOrder";
import { Box, Paper, Tooltip } from "@mui/material";
import moment from 'moment';
import { approveOrder, getOrderDetails, getOrdersListing, rejectOrder } from "../api/context/orders";
import Loader from "../components/loader/loader";
import ordernew from '../assets/images/order-new.png';
import orderexchange from '../assets/images/order-exchange.png';
import orderreturn from '../assets/images/order-return.png';
import toast from 'react-hot-toast';
import { getDashboardApis, getSalesDetails, getSalesPriceDetails, getTotalOrderCount } from "../api/context/dashboard";
import { useNavigate } from "react-router-dom";
import { SelectionContext } from "../Context/Store";
import Select from 'react-select'
import { useFormik } from 'formik'
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import Offcanvas from 'react-bootstrap/Offcanvas';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import { useRecoilState } from "recoil";
import { orderListFilter } from "../atoms/orderListFilter";
import { IoSearch } from "react-icons/io5";
import { FiRefreshCw } from "react-icons/fi";

// Extend dayjs with the plugins
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);

const queueDatatableCustomStyles = {
  header: {
    style: {
      fontWeight: '600',
      fontSize: '20px',
      color: '#000',
    },
  },
  title: {
    style: {
      fontWeight: '600',
    },
  },
  headCells: {
    style: {
      display: "flex",
      justifyContent: "center",
      fontWeight: '600',
      fontSize: '14px',

    },
  },
  cells: {
    style: {
      display: "flex",
      justifyContent: "center",
      fontSize: '12px',
      fontWeight: '500',
      padding: '12px',
      zIndex: '5',
      cursor: "pointer"
    },
  },

};

export const Dashboard = () => {

  const userType = JSON.parse(localStorage.getItem('user'))?.userType;


  const navigate = useNavigate()

  const { ordersTrigger, setOrdersTrigger } = useContext(SelectionContext)

  const [filterData, setFilterdata] = useRecoilState(orderListFilter);

  const [show, setShow] = useState(false)
  const [orders, setOrders] = useState([]);
  const [pendingOrders, setPendingOrders] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [loading, setLoading] = useState(false);
  const [dashboardLoading, setDashboardLoading] = useState(false);
  const [ordersLoading, setOrdersLoading] = useState(false);
  const [limit, setLimit] = useState(5);
  const [page, setPage] = useState(1);
  const [limitactive, setLimitActive] = useState(10);
  const [pageactive, setPageActive] = useState(1);
  const [limitinactive, setLimitInactive] = useState(10);
  const [pageinactive, setPageInactive] = useState(1);
  const [refreshing, setRefreshing] = useState(false);
  const [update, setUpdate] = useState(false);
  const [updateDashboard, setUpdateDasboard] = useState(false);
  const [initial, setInitial] = useState(false);
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState("all");
  const [orderData, setOrderData] = useState([]);
  const [orderId, setOrderID] = useState();
  const [dashboard, setDashboard] = useState([]);
  const [sales, setSales] = useState([]);
  const [salesprice, setSalesPrice] = useState([]);
  // const [selectedMonth, setSelectedMonth] = useState("");
  // const [currentInactiveMonth, setCurrentInactiveMonth] = useState("0");
  // const [currentactiveMonth, setCurrentactiveMonth] = useState("0");
  // const [showCustomRange, setShowCustomRange] = useState(false);
  // const [showCustomRangeSale, setShowCustomRangeSale] = useState(false);
  const [showOff, setShowOff] = useState(false);
  const [checkoutErrorShown, setCheckoutErrorShown] = useState(false);
  const [totalOrdersCountPO, setTotalOrdersCountPO] = useState(5);
  const [isMobile, setIsMobile] = useState(false);
  const [currentOrderReceivedMonth, setCurrentOrderReceivedMonth] = useState("0");
  const [showCustomRangeOrderReceived, setShowCustomRangeOrderReceived] = useState(false);
  const [orderReceivedDateRange, setOrderReceivedDateRange] = useState({ startDate: '', endDate: '' });
  const [orderReceivedCounts, setOrderReceivedCounts] = useState([]);
  const [activeTab, setActiveTab] = useState('ALL');
  // Add this with your other state declarations
  const [globalFilter, setGlobalFilter] = useState({
    timeRange: "0", // Default to "This Month"
    startDate: '',
    endDate: '',
    showCustomRange: false
  });

  const handleCloseOff = () => setShowOff(false);
  const handleShowOff = () => setShowOff(true);

  const orderTypeOptions = [
    { value: null, label: 'NEW' },
    { value: 1, label: 'RETURN' },
    { value: 2, label: 'EXCHANGE' },
    { value: 3, label: 'DELIVERED' },
  ]

  const paymentModeOptions = [
    { value: "COD", label: 'COD' },
    { value: "ONLINE", label: 'ONLINE' },
  ]

  const paymentStatusOptions = [
    { value: "PENDING", label: 'PENDING' },
    { value: "DONE", label: 'DONE' },
  ]

  const handleShow = (rowId) => {
    setShow(true)
    setOrderID(rowId)
    setLoading(true)
    getOrderDetails(rowId)((response) => {
      if (response?.data?.statusCode == 200) {
        setOrderData(response?.data?.data?.[0]);
        setLoading(false)
      } else {
        setOrderData([])
        setLoading(false)
      }
    })
  }

  const handleClose = () => {
    setShow(false)
  }


  const columns = [
    {
      name: "S. No.",
      selector: (row, index) => {
        if (filter === "all") {
          return page * limit - limit + (index + 1);
        } else if (filter === "completed") {
          return pageactive * limitactive - limitactive + (index + 1);
        } else if (filter === "rejected") {
          return pageinactive * limitinactive - limitinactive + (index + 1);
        } else {
          return page * limit - limit + (index + 1);
        }
      },
      width: isMobile ? "70px" : "90px",
      center: true
    },
    {
      id: 'orderId',
      name: 'Order Id',
      selector: (row) => row?.orderId,
      cell: (row) => (
        <div className="d-flex justify-content-center">
          <Tooltip title={row?.orderId} disableInteractive placement='top'>
            <div className="related-order-box"
              style={{
                backgroundColor: 'rgba(70, 70, 70, 0.1)' // 50% transparent
                ,
                color: 'black',
                padding: '4px 8px',
                borderRadius: '4px',
                fontWeight: '500',
                cursor: 'pointer',
                minWidth: '80px',
                textAlign: 'center',
                margin: '2px'
              }}
              onClick={(e) => {
                e.stopPropagation();
                navigate(`/orderdetails/${row.id}`);
              }}>{row?.orderId}</div>
          </Tooltip>
        </div>

      ),

      grow: 0.5,
      minWidth: "200px",
      center: true
    },
    {
      id: 'createdAt',
      name: 'Date',
      selector: (row) => moment(row?.createdAt).format('DD/MM/YYYY, hh:mm a'),
      cell: (row) => (
        <div className="d-flex justify-content-center">
          <Tooltip title={moment(row?.createdAt).format('DD/MM/YYYY, hh:mm a')} disableInteractive placement='top'>
            <div className='text-truncate'>{moment(row?.createdAt).format('DD/MM/YYYY, hh:mm a')}</div>
          </Tooltip>
        </div>
      ),
      grow: 0.5,
      minWidth: isMobile ? "100px" : "150px",
      center: true
    },
    {
      name: "Order Status",
      cell: (row) => {
        const status = row?.status;
        let bgColor = '';
        let textColor = 'white';

        // Set colors based on status
        switch (status) {
          case "CANCELLED":
            bgColor = '#dc3545'; // Red
            break;
          case "INITIATED":
            bgColor = '#ffc107'; // Yellow (warning)
            textColor = '#212529'; // Dark text for better contrast
            break;
          case "CONFIRMED":
            bgColor = '#17a2b8'; // Teal
            break;
          case "DELIVERED":
            bgColor = '#28a745'; // Green
            break;
          case "REJECTED":
            bgColor = '#dc3545';// Red
            break;
          default:
            bgColor = '#6f42c1'; // Purple (fallback)
        }

        return (
          <div className="d-flex justify-content-center">
            <div className="text-capitalize">
              {status ? (
                <span
                  style={{
                    backgroundColor: bgColor,
                    color: textColor,
                    padding: '4px 8px',
                    borderRadius: '4px',
                    fontWeight: '500'
                  }}
                >
                  {status.toLowerCase().split('_').map(word =>
                    word.charAt(0).toUpperCase() + word.slice(1)
                  ).join(' ')}
                </span>
              ) : (
                'N/A'
              )}
            </div>
          </div>
        );
      },
      sortable: true,
      center: true,
      minWidth: isMobile ? "100px" : "150px",
      selector: (row) => row.status
    },
    {
      id: 'orderType',
      name: 'Order Type',
      selector: (row) => row?.orderType,
      cell: (row) => (
        <div className="d-flex justify-content-center">
          <Tooltip title={row?.orderType === 3 ? "Delivered" : row?.orderType === 2 ? "Exchange" : row?.orderType === 1 ? "Return" : "New"} disableInteractive placement='top'>
            <div className={`${row?.orderType == null ? "gradient-border" : "gradient-border"}`}>
              <div className='text-truncate'>
                {row?.orderType === 3 && <img className='order-new' src={ordernew} alt='Order New' />}
                {row?.orderType === 2 && <img className='order-new' src={orderexchange} alt='Order Exchange' />}
                {row?.orderType === 1 && <img className='order-new' src={orderreturn} alt='Order Return' />}
                {row?.orderType == null && <img className='order-new' src={ordernew} alt='Order New' />}
                {row?.orderType === 3 ? "Delivered" : row?.orderType === 2 ? "Exchange" : row?.orderType === 1 ? "Return" : "New"}
              </div>
            </div>
          </Tooltip>
        </div>
      ),
      center: true,
      grow: 0.3,
      minWidth: isMobile ? "100px" : "170px"
    },

    {
      id: 'amount',
      name: 'Amount',
      selector: (row) => userType === 'ADMIN' ? row?.amount : row?.billingAmount,
      cell: (row) => (
        <div className="d-flex justify-content-center">
          <Tooltip title={userType === 'ADMIN' ? row?.amount : row?.billingAmount} disableInteractive placement='top'>
            <div className='text-truncate'>{userType === 'ADMIN' ? row?.amount : row?.billingAmount}</div>
          </Tooltip>
        </div>
      ),
      center: true,
      grow: 0.5,
      minWidth: isMobile ? "100px" : "90px"
    },
    {
      name: 'Return Id',
      cell: (row) => {
        let returnIds = [];

        if (row.returnIdForVedor) {
          if (typeof row.returnIdForVedor === 'string') {
            returnIds = row.returnIdForVedor.split(',').map(id => id.trim());
          } else if (Array.isArray(row.returnIdForVedor)) {
            returnIds = row.returnIdForVedor;
          }
        }

        return (
          <div className="d-flex justify-content-center flex-wrap gap-1">
            {returnIds.length > 0 ? (
              returnIds.map((id, index) => (
                <Tooltip
                  key={`return-${id}-${index}`}
                  title={`View Return Order: ${id}`}
                  disableInteractive
                  placement="top"
                >
                  <span
                    style={{
                      color: 'red',
                      textDecoration: 'underline',
                      cursor: 'pointer',
                      fontWeight: '600',
                      margin: '2px',
                      fontSize: '14px'
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate(`/orderdetails/${id}`);
                    }}
                  >
                    {id}
                  </span>
                </Tooltip>
              ))
            ) : (
              <div className="text-truncate">-</div>
            )}
          </div>
        );
      },
      center: true,
      minWidth: '150px',
      ignoreRowClick: true,
    },
    {
      name: 'Exchange Id',
      cell: (row) => {
        let exchangeIds = [];

        if (row.exchangeIdForVedor) {
          if (typeof row.exchangeIdForVedor === 'string') {
            exchangeIds = row.exchangeIdForVedor.split(',').map(id => id.trim());
          } else if (Array.isArray(row.exchangeIdForVedor)) {
            exchangeIds = row.exchangeIdForVedor;
          }
        }

        return (
          <div className="d-flex justify-content-center flex-wrap gap-1">
            {exchangeIds.length > 0 ? (
              exchangeIds.map((id, index) => (
                <Tooltip
                  key={`exchange-${id}-${index}`}
                  title={`View Exchange Order: ${id}`}
                  disableInteractive
                  placement="top"
                >
                  <span
                    style={{
                      color: '#0b6a93ff',
                      textDecoration: 'underline',
                      cursor: 'pointer',
                      fontWeight: '600',
                      margin: '2px',
                      fontSize: '14px'
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate(`/orderdetails/${id}`);
                    }}
                  >
                    {id}
                  </span>
                </Tooltip>
              ))
            ) : (
              <div className="text-truncate">-</div>
            )}
          </div>
        );
      },
      center: true,
      minWidth: '150px',
      ignoreRowClick: true,
    },
    {
      name: "Payment Status",
      cell: (row) => {
        const status = row?.paymentStatus;
        let bgColor = '';
        let textColor = 'white';

        if (status === "DONE") {
          bgColor = '#28a745'; // Green for completed
        } else {
          bgColor = '#dc7235ff'; // Red for pending
        }

        return (
          <div className="d-flex justify-content-center">
            <div className="text-capitalize">
              {status ? (
                <span
                  style={{
                    backgroundColor: bgColor,
                    color: textColor,
                    padding: '4px 8px',
                    borderRadius: '4px',
                    fontWeight: '500'
                  }}
                >
                  {status === "DONE" ? "Completed" : "Pending"}
                </span>
              ) : (
                'N/A'
              )}
            </div>
          </div>
        );
      },
      center: true,
      minWidth: isMobile ? "100px" : "180px",
      sortable: true
    },
    // {
    //   name: "Actions",
    //   cell: (row) => (
    //     <div className="d-flex justify-content-center">
    //       <div className="three_dots" onClick={() => handleShow(row?.id)}>
    //         <BsThreeDots />
    //       </div>
    //     </div>
    //   ),
    //   center: true,
    //   minWidth: isMobile ? "100px" : "100px"
    // }
  ];

  const handlePerRowsChange = (newPerPage, page) => {
    setLimit(newPerPage);
    setPage(1);
    setUpdate(!update);
  };

  const handlePageChange = (page) => {
    setPage(page);
    setUpdate(!update);
  };

  const searchFormik = useFormik({
    initialValues: {
      startDate: filterData.startDate || '',
      endDate: filterData.endDate || '',
      orderType: filterData.orderType || '',
      selected_orderType: filterData.selected_orderType || '',
      paymentMode: filterData.paymentMode || '',
      selected_paymentMode: filterData.selected_paymentMode || '',
      paymentStatus: filterData.paymentStatus || '',
      selected_paymentStatus: filterData.selected_paymentStatus || ''
    },
    validate: async (values) => {
      // Add validation logic if needed
    },
    onSubmit: (values, { resetForm }) => {
      setLoading(true);
      setFilterdata(values);
      setShowOff(false);
    },
  });

  const revenewFormik = useFormik({
    initialValues: {
      startDate: '',
      endDate: '',
    },
    onSubmit: (values) => {
      getAllSalesPriceDetails({
        startDate: values.startDate,
        endDate: values.endDate,
      });
    },
  });

  const salesFormik = useFormik({
    initialValues: {
      startDate: '',
      endDate: '',
    },
    onSubmit: (values) => {
      getAllSalesDetails({
        startDate: values.startDate,
        endDate: values.endDate,
      });
    },
  });


  const fetchAllPendingOrders = async () => {
    const params = {
      "startDate": "",
      "endDate": "",
      "orderType": "",
      "selected_orderType": "",
      "paymentMode": "",
      "selected_paymentMode": "",
      "paymentStatus": "",
      "selected_paymentStatus": "",
      "page": 1,
      "limit": totalOrdersCountPO,
      "search": ""
    }
    getOrdersListing(params)((response) => {
      if (response?.statusCode === 200) {
        let totalOrders = response?.data?.orders;
        let pendingOrders = totalOrders.filter((order) => order.status === 'INITIATED');
        setPendingOrders(pendingOrders);
        setTotalOrdersCountPO(response?.data?.totalItems);
        setOrdersLoading(false);
      } else {
        setPendingOrders([]);
        setTotalOrdersCountPO(5);
        setOrdersLoading(false);
      }
    });
  }

  const fetchOrdersData = async (filter) => {

    const params = filterData ? { ...filterData, page, limit, search } : { page, limit, search };



    if (filter === 'completed') {
      //returns the orders which are confirmed
      params.status = 'CONFIRMED';
    }

    if (filter === 'rejected') {
      params.status = 'REJECTED';
    }

    if (filter === 'initiated') {
      params.status = 'INITIATED';
    }

    if (filter === 'delivered') {
      params.status = 'DELIVERED';
    }



    if (filter === 'cancelled') {
      params.status = 'CANCELLED';
    }

    params.orderType = null;


    getOrdersListing(params)((response) => {
      if (response?.statusCode === 200) {
        let totalOrders = response?.data?.orders;
        let mostRecentOrders = response?.data?.orders;
        setOrders(mostRecentOrders);
        setTotalRows(response?.data?.totalItems);
        // setLimit(response?.data?.totalItems);
        setOrdersLoading(false);
      } else {
        setOrders([]);
        setOrdersLoading(false);
      }
    });
  };

  const handleRefresh = async () => {
    setRefreshing(true);
    setDashboardLoading(true);
    setOrdersLoading(true);

    try {
      // Refresh all data in parallel
      await Promise.all([
        getAllDashboardApis(),
        getAllSalesDetails({ monthId: 0 }),
        getAllSalesPriceDetails({ monthId: 0 }),
        fetchOrdersData(filter),
        fetchAllPendingOrders(),
      ]);

      // Re-apply current filters
      if (globalFilter.timeRange === "4" && globalFilter.startDate && globalFilter.endDate) {
        applyGlobalFilter("4", globalFilter.startDate, globalFilter.endDate);
      } else {
        applyGlobalFilter(globalFilter.timeRange, "", "");
      }

      toast.success('Dashboard refreshed successfully!');
    } catch (error) {
      console.error('Refresh failed:', error);
      toast.error('Failed to refresh data');
    } finally {
      setTimeout(() => {
        setRefreshing(false);
        setDashboardLoading(false);
        setOrdersLoading(false);
      }, 500);
    }
  };

  const handleFilterChange = (filter) => {
    setPage(1);
    setPageActive(1);
    setPageInactive(1);
    setFilter(filter);
  };

  // For approving order
  const handleApproveOrder = () => {
    handleOrderStatusChange("CONFIRMED", "Order accepted successfully");
  };

  const handleOrderStatusChange = (status, successMessage) => {
    approveOrder({ orderIds: [orderId], status })((response) => {
      if (response?.data?.statusCode == 200) {
        toast.success(response?.data?.message || successMessage, 'success');
        setUpdateDasboard(!updateDashboard)
        setShow(false)
      } else {
        toast.error(response?.data?.message ? response?.data?.message : "Something went wrong", 'error')
      }
    })
  }

  const handleCancelOrder = () => {
    rejectOrder({ orderIds: [orderId] })((response) => {
      if (response?.data?.statusCode == 200) {
        toast.success(response?.data?.message ? response?.data?.message : "Order cancelled successfully", 'success')
        setUpdateDasboard(!updateDashboard)
        setShow(false)
      } else {
        toast.error(response?.data?.message ? response?.data?.message : "Something went wrong", 'error')
      }
    })
  }

  const getAllDashboardApis = () => {
    getDashboardApis()((response) => {
      if (response?.statusCode == 200) {
        const data = response?.data;
        setDashboard(data);
        //todo:  the api is giving incorrect data. 
        // const totalOrders = data.completedOrders + data.pendingOrders + data.approvedOrders;
        // const completedPercentage = totalOrders > 0 ? ((data.completedOrders / totalOrders) * 100).toFixed(2) : 0;
        // const pendingPercentage = totalOrders > 0 ? ((data.pendingOrders / totalOrders) * 100).toFixed(2) : 0;
        // const approvedPercentage = totalOrders > 0 ? ((data.approvedOrders / totalOrders) * 100).toFixed(2) : 0;

      } else {
      }
    });
  };

  const getAllSalesDetails = (params, onComplete) => {
    const payload = params.months
      ? { months: params.months }
      : { startDate: params.startDate, endDate: params.endDate };

    console.log('🛒 Fetching sales details with:', payload);

    getSalesDetails(payload)((response) => {
      if (response?.data?.statusCode === 200) {
        const salesData = {
          totalQuantitySold: parseInt(response?.data?.data?.totalQuantitySold) || 0,
          totalOrders: parseInt(response?.data?.data?.totalOrders) || 0
        };
        setSales(salesData);
        console.log('✅ Sales data received:', salesData);
      } else {
        setSales({
          totalQuantitySold: 0,
          totalOrders: 0
        });
        console.log('❌ Sales data fetch failed');
      }
      onComplete?.();
    });
  };

  // Similarly update other API functions

  const getAllSalesPriceDetails = (params) => {
    console.log('💰 getAllSalesPriceDetails called with:', params);

    const payload = params.months !== undefined && params.months !== ""
      ? { months: params.months } // For predefined months
      : { startDate: params.startDate, endDate: params.endDate }; // For custom range

    console.log('💰 Sales price API payload:', payload);

    getSalesPriceDetails(payload)((response) => {
      if (response?.data?.statusCode === 200) {
        console.log('✅ Total Revenue data received:', response?.data?.data?.[0]);
        setSalesPrice(response?.data?.data?.[0]);
      } else {
        console.log('❌ Total Revenue data fetch failed');
        setSalesPrice({ totalRevenue: 0 });
      }
    });
  };


  const handleReset = () => {
    searchFormik.resetForm({
      values: {
        startDate: "",
        endDate: '',
        orderType: "",
        selected_orderType: "",
        paymentMode: "",
        selected_paymentMode: "",
        paymentStatus: "",
        selected_paymentStatus: ""
      }
    });
    setFilterdata({
      startDate: "",
      endDate: '',
      orderType: "",
      selected_orderType: "",
      paymentMode: "",
      selected_paymentMode: "",
      paymentStatus: "",
      selected_paymentStatus: ""
    });
    setSearch('');
    setShowOff(false);
    setUpdate(!update);
  };


  const handleFilterSubmit = (e) => {
    e.preventDefault();
    if (isFilterApplied) {
      searchFormik.handleSubmit(e);
    } else {
      handleReset();
    }
  };

  useEffect(() => {
    let screenwidth = window.innerWidth;
    if (screenwidth < 576) {
      setIsMobile(true);
    }
  }, []);

  useEffect(() => {
    setOrdersLoading(true); // Use ordersLoading instead of loading
    fetchOrdersData(filter);
  }, [update, filter, filterData, updateDashboard, limit]);

  useEffect(() => {
    setOrdersLoading(true); // Use ordersLoading instead of loading
    fetchAllPendingOrders();
  }, [totalOrdersCountPO, update, updateDashboard]);

  useEffect(() => {
    if (ordersTrigger) {
      fetchOrdersData(filter);
      getAllDashboardApis();
      setOrdersTrigger(false);
    }
  }, [ordersTrigger]);

  useEffect(() => {
    setLoading(true);
    getAllDashboardApis();
  }, [updateDashboard]);

  useEffect(() => {
    getAllSalesDetails({ monthId: 0 });
    getAllSalesPriceDetails({ monthId: 0 });
  }, []);

  useEffect(() => {
    let timeout = setTimeout(() => {
      if (initial) setUpdate(!update);
      else setInitial(!initial);
    }, 500);

    return () => {
      clearTimeout(timeout);
    };
  }, [search]);

  const conditionalRowStyles = [

    {
      when: row => row.returnIdForVedor !== null,
      style: {
        backgroundColor: 'rgba(238, 145, 155, 0.1)', // Very light red
        '&:hover': {
          backgroundColor: 'rgba(238, 145, 155, 0.15)' // Slightly darker on hover
        }
      },
    },
    {
      when: row => row.exchangeIdForVedor !== null,
      style: {
        backgroundColor: 'rgba(0, 140, 255, 0.1)', // Very light blue
        '&:hover': {
          backgroundColor: 'rgba(0, 140, 255, 0.15)' // Slightly darker on hover
        }
      },
    },
    {
      when: row => row.returnIdForVedor !== null && row.exchangeIdForVedor !== null,
      style: {
        backgroundColor: 'rgba(180, 120, 255, 0.1)', // Light purple
        '&:hover': {
          backgroundColor: 'rgba(180, 120, 255, 0.15)' // Slightly darker on hover
        }
      },
    },
  ];



  const [chartData, setChartData] = useState({
    series: [],
    options: {
      chart: {
        width: 370,
        type: 'pie',
      },
      labels: [],
      colors: ['#1098ad', '#FEE12B', '#f37055', '#6fba82', '#ef4e7b', '#a166ab', '#d30000'],
      dataLabels: {
        enabled: false,
      },
      responsive: [{
        breakpoint: 576,
        options: {
          chart: {
            width: 300,
          },
          legend: {
            position: 'bottom',
          },
        },
      }],
    },
  });

  const isFilterApplied = !!(
    searchFormik.values.startDate ||
    searchFormik.values.endDate ||
    searchFormik.values.orderType ||
    searchFormik.values.paymentMode ||
    searchFormik.values.paymentStatus
  );


  const fetchOrderReceivedData = (params) => {
    console.log('📦 Fetching order received data with:', params);

    const payload = params.months !== undefined && params.months !== ""
      ? { months: params.months }
      : { startDate: params.startDate, endDate: params.endDate };

    console.log('📦 Order received API payload:', payload);

    getTotalOrderCount(payload)((response) => {
      if (response?.statusCode === 200) {
        const statusCounts = response?.data?.orders || [];
        setOrderReceivedCounts(statusCounts);

        // Define the desired order and mapping
        const statusOrder = [
          "INITIATED",   // Pending
          "CONFIRMED",   // Confirmed
          "DELIVERED",   // Completed/Delivered
          "REJECTED",    // Rejected
          "CANCELLED",   // Cancelled
        ];

        const statusMap = {
          DELIVERED: { label: "Delivered", color: "#25bcb4" },
          INITIATED: { label: "Pending", color: "#FEE12B" },
          CANCELLED: { label: "Cancelled", color: "#f37055" },
          CONFIRMED: { label: "Confirmed", color: "#1098ad" },
          REJECTED: { label: "Rejected", color: "#d30000" },
        };

        // Map statusCounts to an object for quick lookup
        const countsByStatus = {};
        statusCounts.forEach(item => {
          countsByStatus[item.status] = item.count;
        });

        let total = statusCounts.reduce((sum, item) => sum + item.count, 0);

        // Build labels, series, and colors in the desired order
        const labels = [];
        const series = [];
        const colors = [];

        statusOrder.forEach(status => {
          const count = countsByStatus[status] || 0;
          const map = statusMap[status] || { label: status, color: "#ccc" };
          const percent = total > 0 ? ((count / total) * 100).toFixed(2) : 0;
          labels.push(`${map.label} - ${count} (${percent}%)`);
          series.push(count);
          colors.push(map.color);
        });

        setChartData((prev) => ({
          ...prev,
          series,
          options: {
            ...prev.options,
            labels,
            colors,
            legend: {
              show: true,
              position: 'right',
              labels: {
                colors: '#333',
                useSeriesColors: false,
              },
              itemMargin: {
                vertical: 0
              }
            },
            dataLabels: {
              enabled: false
            }
          },
        }));
        console.log('✅ Order units chart updated');
      } else {
        console.log('❌ Order received data fetch failed');
      }
    });
  };

  useEffect(() => {
    // Apply default filter on component mount
    applyGlobalFilter("0", "", "");

    // Your other initializations...
    getAllDashboardApis();
    fetchAllPendingOrders();
  }, []);


  // useEffect(() => {
  //   if (showCustomRangeOrderReceived) {
  //     if (orderReceivedDateRange.startDate && orderReceivedDateRange.endDate) {
  //       fetchOrderReceivedData(orderReceivedDateRange);
  //     }
  //   } else {
  //     fetchOrderReceivedData({ monthId: currentOrderReceivedMonth });
  //   }
  // }, [currentOrderReceivedMonth, orderReceivedDateRange, showCustomRangeOrderReceived]);


  const applyGlobalFilter = (timeRange, startDate, endDate) => {
    setDashboardLoading(true);

    // Prepare parameters based on filter type
    let salesParams = {};
    let revenueParams = {};
    let orderReceivedParams = {};

    if (timeRange === "4") {
      // Custom date range
      salesParams = { startDate, endDate, months: "" };
      revenueParams = { startDate, endDate, months: "" };
      orderReceivedParams = { startDate, endDate, months: "" };
    } else {
      // Predefined range
      salesParams = { months: timeRange, startDate: "", endDate: "" };
      revenueParams = { months: timeRange, startDate: "", endDate: "" };
      orderReceivedParams = { months: timeRange, startDate: "", endDate: "" };
    }

    console.log('🔄 Applying global filter:', { timeRange, startDate, endDate });
    console.log('📊 Sales params:', salesParams);
    console.log('💰 Revenue params:', revenueParams);
    console.log('📦 Order received params:', orderReceivedParams);

    // Apply to Total Sales card
    getAllSalesDetails(salesParams, () => {
      console.log('✅ Total Sales data fetched');
    });

    // Apply to Total Revenue card - ensure this is called
    getAllSalesPriceDetails(revenueParams);

    // Apply to Order Overview card
    fetchOrderReceivedData(orderReceivedParams);

    // Update global filter state
    setGlobalFilter(prev => ({
      ...prev,
      timeRange,
      startDate: startDate || '',
      endDate: endDate || ''
    }));

    // Reset loading after all APIs complete
    setTimeout(() => {
      setDashboardLoading(false);
    }, 1500);
  };



  return (
    <div>
      <div className="col-12">
        <div className="page-title-box d-sm-flex align-items-center justify-content-between">
          <h3 className="mb-sm-0 fw-bolder">Dashboard</h3>

          {/* Global Filter Section */}
          <div className="d-flex align-items-center gap-3">
            {/* Time Range Selector */}
            <Form.Select
              aria-label="Time range selection"
              value={globalFilter.timeRange}
              onChange={(e) => {
                const value = e.target.value;
                setGlobalFilter(prev => ({
                  ...prev,
                  timeRange: value,
                  startDate: '',
                  endDate: ''
                }));

                // Apply filter immediately for ALL ranges (including predefined ones)
                applyGlobalFilter(value, '', '');
              }}
              className="w-auto"
              style={{ minWidth: '150px' }}
            >
              <option value="0">This Month</option>
              <option value="1">Last Month</option>
              <option value="2">Last 2 Months</option>
              <option value="3">Last 3 Months</option>
              <option value="6">Last 6 Months</option>
              <option value="9">Last 9 Months</option>
              <option value="4">Custom Range</option>
            </Form.Select>
            {/* Date Range Inputs - Always Visible */}
            <div className="d-flex align-items-center gap-2">
              <div className="position-relative">
                <input
                  type="date"
                  className="form-control form-control-sm"
                  value={globalFilter.startDate}
                  onChange={(e) => {
                    const fromDate = e.target.value;

                    // Validate date
                    if (fromDate && globalFilter.endDate && fromDate > globalFilter.endDate) {
                      toast.error('Start date cannot be after end date');
                      return;
                    }

                    const updatedFilter = {
                      ...globalFilter,
                      startDate: fromDate,
                      timeRange: "4"
                    };

                    setGlobalFilter(updatedFilter);

                    // Apply filter if both dates are valid
                    if (fromDate && globalFilter.endDate && fromDate <= globalFilter.endDate) {
                      applyGlobalFilter("4", fromDate, globalFilter.endDate);
                    }
                  }}
                  style={{ width: '140px' }}
                  placeholder="Start Date"
                  max={globalFilter.endDate || undefined}
                />
              </div>

              <div className="text-muted small">to</div>

              <div className="position-relative">
                <input
                  type="date"
                  className="form-control form-control-sm"
                  value={globalFilter.endDate}
                  onChange={(e) => {
                    const toDate = e.target.value;

                    // Validate date
                    if (toDate && globalFilter.startDate && toDate < globalFilter.startDate) {
                      toast.error('End date cannot be before start date');
                      return;
                    }

                    const updatedFilter = {
                      ...globalFilter,
                      endDate: toDate,
                      timeRange: "4"
                    };

                    setGlobalFilter(updatedFilter);

                    // Apply filter if both dates are valid
                    if (globalFilter.startDate && toDate && toDate >= globalFilter.startDate) {
                      applyGlobalFilter("4", globalFilter.startDate, toDate);
                    }
                  }}
                  style={{ width: '140px' }}
                  placeholder="End Date"
                  min={globalFilter.startDate || undefined}
                />
              </div>

              {/* Clear Button - Shows when filter is active */}
              {(globalFilter.timeRange === "4" || globalFilter.startDate || globalFilter.endDate) && (
                <button
                  onClick={() => {
                    setGlobalFilter({
                      timeRange: "0",
                      startDate: "",
                      endDate: "",
                      showCustomRange: false
                    });
                    applyGlobalFilter("0", "", "");
                    toast.success('Filters cleared!');
                  }}
                  className="btn btn-sm btn-outline-secondary"
                >
                  Clear
                </button>
              )}
            </div>

            <div className="d-flex align-items-center gap-2">
              {/* Refresh Button */}
              <button
                onClick={handleRefresh}
                className="btn border border-secondary bg-transparent rounded-3 p-2"
                style={{
                  width: '40px',
                  height: '40px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
                disabled={refreshing}
              >
                <FiRefreshCw
                  className="text-secondary"
                  size={18}
                  style={{
                    transition: 'transform 0.3s ease-in-out',
                    transform: refreshing ? 'rotate(360deg)' : 'rotate(0deg)',
                    animation: refreshing ? 'spin 1s linear infinite' : 'none'
                  }}
                />
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* performance section of dashboard */}
      <div className="row">


        {/* total sales  */}
        <div className="col-lg-6 col-md-12">
          <div className="dashboard_contents shadow-sm">
            <div className="top_contents d-flex justify-content-between align-items-start flex-wrap">
              <div className="col-6 top_contents_left">
                <h5 className="fs-5 mb-0">Total Sales</h5>
                <p className="fs-7 fs-md-5 mb-0 md-fs-5">
                  {globalFilter.timeRange === "4" && globalFilter.startDate && globalFilter.endDate
                    ? `This represents total Sales from ${dayjs(globalFilter.startDate).format('DD/MM/YYYY')} to ${dayjs(globalFilter.endDate).format('DD/MM/YYYY')}.`
                    : `This represents total Sales in ${globalFilter.timeRange == 0 ? 'current' : globalFilter.timeRange} month.`}
                </p>
              </div>
            </div>
            <div className="bottom_contents">
              <div className="d_flex_wrapper">
                <div style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  gap: '20px'
                }}>
                  <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    minWidth: '80px'
                  }}>
                    <h1>{sales?.totalOrders ?? 0}</h1>
                    <span style={{ fontSize: '14px', color: '#666', marginTop: '5px' }}>(orders)</span>
                  </div>
                  <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    minWidth: '80px'
                  }}>
                    <h1>{sales?.totalQuantitySold ?? 0}</h1>
                    <span style={{ fontSize: '14px', color: '#666', marginTop: '5px' }}>(units)</span>
                  </div>
                </div>
              </div>
              <img className="img-fluid" src={graphimage} alt="graphical" style={{ maxHeight: "70px", height: "auto", width: "auto" }} />
            </div>
          </div>
        </div>


        {/* new orders */}
        <div className="col-lg-6 col-md-12">
          <div className={`dashboard_contents_new_order ${pendingOrders.length > 0 ? 'new_order_received' : ''}`}>
            <div className="top_contents">
              <h5 className="fs-5 fs-md-4 fs-lg-3 mb-0">New Order Requests ({pendingOrders.length})</h5>
              <p role="button" onClick={() => navigate('/orders')} className="fs-6 fs-md-5 mb-0">View All</p>
            </div>
            <div className="new_orders_request">
              {pendingOrders?.map((order, index) => (
                <div className="new_order_contents" key={index} role="button" onClick={() => navigate('/orderdetails/' + order?.id)}>

                  <div className="pos-relative">
                    <div>
                      <h6 className="fs-10 fs-md-5 mb-0">Order Id: {order?.orderId}</h6>
                      <p className="fs-9 fs-md-7 mb-0">{moment(order?.createdAt).format('MMM D, YYYY, h:mm:ss A')}</p>
                    </div>
                    <div className="gradient-border-pos">
                      <div className={`${order?.orderType == null
                        ? "gradient-border-dash"
                        : "gradient-border-dash"
                        }`}>
                        <div className='text-truncate-dash'>
                          {order?.orderType === 2 && (
                            <img className='order-new' src={orderexchange} alt='Order Exchange' />
                          )}
                          {order?.orderType === 1 && (
                            <img className='order-new' src={orderreturn} alt='Order Return' />
                          )}
                          {order?.orderType == null && (
                            <img className='order-new' src={ordernew} alt='Order New' />
                          )}
                          {order?.orderType === 3 && (
                            <img className='order-new' src={ordernew} alt='Order New' />
                          )}
                          {order?.orderType === 3 ? "Delivered" : order?.orderType === 2 ? "Exchange" : order?.orderType === 1 ? "Return" : "New"}
                        </div>
                      </div>
                    </div>
                  </div>
                  <img role="button" src={showIcon} alt="show-icon" onClick={() => navigate('/orderdetails/' + order?.id)} />
                </div>
              ))}
            </div>
            {/* <div className="order_contents">
              <div>
                <h6>Order Id:#2368</h6>
                <p>Jan 21,2023</p>
              </div>
              <img src={showIcon} alt="show-icon" />
            </div> */}
          </div>
        </div>




        {/* total revenue */}
        <div className="col-lg-6 col-md-12">
          <div className="dashboard_contents shadow-sm">
            <div className="top_contents d-flex justify-content-between align-items-start flex-wrap">
              <div className="col-6 top_contents_left">
                <h5 className="fs-5 mb-0">Total Revenue</h5>
                <p className="fs-7 fs-md-5 mb-1 md-fs-5">
                  {globalFilter.timeRange === "4" && globalFilter.startDate && globalFilter.endDate
                    ? `This represents total Revenue from ${dayjs(globalFilter.startDate).format('DD/MM/YYYY')} to ${dayjs(globalFilter.endDate).format('DD/MM/YYYY')}.`
                    : `This represents total Revenue in ${globalFilter.timeRange == 0 ? 'current' : globalFilter.timeRange} month.`}
                </p>
              </div>
            </div>
            <div className="bottom_contents">
              <h1>Rs. {salesprice?.totalRevenue ? salesprice?.totalRevenue?.toLocaleString('en-IN') : "0"}</h1>
              <img className="img-fluid" src={graphimage} alt="graphical" style={{ maxHeight: "70px", height: "auto", width: "auto" }} />
            </div>
          </div>
        </div>



        {/* total order received */}
        <div className="col-lg-6 col-md-12">
          <div className="dashboard_contents shadow-sm">
            <div className="top_contents d-flex justify-content-between align-items-start flex-wrap">
              <div className="col-12 top_contents_left">
                <h5 className="fs-5 mb-0">Order Units Overview </h5>
                <p className="fs-7 fs-md-5 mb-0 md-fs-5">
                  {globalFilter.timeRange === "4" && globalFilter.startDate && globalFilter.endDate
                    ? `This represents order units from ${dayjs(globalFilter.startDate).format('DD/MM/YYYY')} to ${dayjs(globalFilter.endDate).format('DD/MM/YYYY')}.`
                    : `This represents order units in ${globalFilter.timeRange == 0 ? 'current' : globalFilter.timeRange} month.`}
                </p>
              </div>
            </div>
            <div className="">
              {dashboardLoading ? (
                <div className="text-center py-5">
                  <div className="spinner-border text-light" role="status">

                  </div>
                </div>
              ) : (
                // Check if there's any data to display
                chartData.series && chartData.series.length > 0 && chartData.series.some(value => value > 0) ? (
                  <ReactApexChart
                    options={chartData.options}
                    series={chartData.series}
                    type="donut"
                    width={370}
                    height={300}
                  />
                ) : (
                  <div className="text-center pb-5">
                    <div >
                      <span className="text-grey fw-medium">No data available</span>

                    </div>
                  </div>
                )
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="col-12">
        <div className="page-title-box d-sm-flex align-items-center justify-content-between">
          <h4 className="mb-sm-0 mt-5 fw-bolder">Recent Orders</h4>
        </div>
      </div>


      {/* order section of dashboard */}
      <div >
        <div className="filter_wrapper">
          {/* Add the tabs navigation */}
          <div className="mb-4">
            <Nav
              variant="tabs"
              defaultActiveKey="CONFIRMED"
              activeKey={activeTab}
              onSelect={setActiveTab}
              className="mb-4 custom-order-tabs"
            >
              <Nav.Item>
                <Nav.Link
                  eventKey="ALL"
                  className={`fs-7 fw-semibold ${activeTab === 'ALL' ? 'fw-bold text-dark active-tab' : 'text-secondary'}`}
                  style={{
                    padding: '12px 24px',
                    backgroundColor: activeTab === 'ALL' ? '#f8f9fa' : 'transparent',
                    transition: 'all 0.3s ease',
                    color: activeTab === 'ALL' ? '#000' : '#6c757d'
                  }}
                  onClick={() => handleFilterChange("all")}
                >
                  All Orders
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link
                  eventKey="INITIATED"
                  className={`fs-7 fw-semibold ${activeTab === 'INITIATED' ? 'fw-bold text-dark active-tab' : 'text-secondary'}`}
                  style={{
                    padding: '12px 24px',
                    backgroundColor: activeTab === 'INITIATED' ? '#f8f9fa' : 'transparent',
                    transition: 'all 0.3s ease',
                    color: activeTab === 'INITIATED' ? '#000' : '#6c757d'
                  }}
                  onClick={() => handleFilterChange("initiated")}
                >
                  Initiated
                </Nav.Link>
              </Nav.Item>

              <Nav.Item>
                <Nav.Link
                  eventKey="CONFIRMED"
                  className={`fs-7 fw-semibold ${activeTab === 'CONFIRMED' ? 'fw-bold text-dark active-tab' : 'text-secondary'}`}
                  style={{
                    padding: '12px 24px',
                    backgroundColor: activeTab === 'CONFIRMED' ? '#f8f9fa' : 'transparent',
                    transition: 'all 0.3s ease',
                    color: activeTab === 'CONFIRMED' ? '#000' : '#6c757d'
                  }}
                  onClick={() => handleFilterChange("completed")}
                >
                  Confirmed
                </Nav.Link>
              </Nav.Item>

              <Nav.Item>
                <Nav.Link
                  eventKey="DELIVERED"
                  className={`fs-7 fw-semibold ${activeTab === 'DELIVERED' ? 'fw-bold text-dark active-tab' : 'text-secondary'}`}
                  style={{
                    padding: '12px 24px',
                    backgroundColor: activeTab === 'DELIVERED' ? '#f8f9fa' : 'transparent',
                    transition: 'all 0.3s ease',
                    color: activeTab === 'DELIVERED' ? '#000' : '#6c757d'
                  }}
                  onClick={() => handleFilterChange("delivered")}
                >
                  Delivered
                </Nav.Link>
              </Nav.Item>

              <Nav.Item>
                <Nav.Link
                  eventKey="REJECTED"
                  className={`fs-7 fw-semibold ${activeTab === 'REJECTED' ? 'fw-bold text-dark active-tab' : 'text-secondary'}`}
                  style={{
                    padding: '12px 24px',
                    backgroundColor: activeTab === 'REJECTED' ? '#f8f9fa' : 'transparent',
                    transition: 'all 0.3s ease',
                    color: activeTab === 'REJECTED' ? '#000' : '#6c757d'
                  }}
                  onClick={() => handleFilterChange("rejected")}
                >
                  Rejected
                </Nav.Link>
              </Nav.Item>

              <Nav.Item>
                <Nav.Link
                  eventKey="CANCELLED"
                  className={`fs-7 fw-semibold ${activeTab === 'CANCELLED' ? 'fw-bold text-dark active-tab' : 'text-secondary'}`}
                  style={{
                    padding: '12px 24px',
                    backgroundColor: activeTab === 'CANCELLED' ? '#f8f9fa' : 'transparent',
                    transition: 'all 0.3s ease',
                    color: activeTab === 'CANCELLED' ? '#000' : '#6c757d'
                  }}
                  onClick={() => handleFilterChange("cancelled")}
                >
                  Cancelled
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </div>
        </div>
      </div>

      {/* DataTable for all tabs */}
      <div className="col-12">
        <Box className="products-and-options" sx={{ mt: 1 }}>
          <Paper square className="shadow-none border border-blue-grey-200">
            <div>
              <DataTable
                columns={columns}
                conditionalRowStyles={conditionalRowStyles}
                data={orders}
                progressPending={ordersLoading} // Use ordersLoading instead of loading
                progressComponent={<div style={{ height: "60vh" }}><Loader /></div>}
                pagination
                paginationServer
                paginationTotalRows={totalRows}
                paginationPerPage={limit}
                paginationRowsPerPageOptions={[5, 10, 50, 100, 150]}
                onRowClicked={(row) => navigate(`/orderdetails/${row?.id}`)}
                onChangeRowsPerPage={handlePerRowsChange}
                onChangePage={handlePageChange}
                currentPage={page}
                customStyles={queueDatatableCustomStyles}
              />
            </div>
          </Paper>
        </Box>
      </div>


      {/* CSS Styles */}
      <style>
        {`
                .hide-scrollbar::-webkit-scrollbar {
                    display: none; /* Chrome, Safari */
                }
                .hide-scrollbar {
                    -ms-overflow-style: none;  /* IE and Edge */
                    scrollbar-width: none;     /* Firefox */
                }
                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
                `}
      </style>


    </div>
  );
};
